import { Grid } from "@mui/material";
import { SpinnerLoading } from "../shared/Spinner/SpinnerLoading";
import FormField from "../shared/TextField/FormField";
import {
  ClinicOrderingProviderSection,
  ClinicSpinnerWrapper,
  NewRequisitionTextField,
} from "./NewRequisition.styles";
import { NewRequisitionForm } from "../../recoil/types";
import { useClinicInformation } from "./useClinicInformation";

const ClinicInformation: React.FC<{
  preflight: boolean;
  isError?: boolean;
  isDraftError?: boolean;
  submittedRequisition?: NewRequisitionForm;
  isEditMode?: boolean;
}> = ({
  preflight,
  submittedRequisition,
  isError,
  isDraftError,
  isEditMode = false,
}) => {
  const {
    activeRequisition,
    clinicAutocompleteOptions,
    effectiveIsError,
    filteredFormattedOrderingProviders,
    isLoading,
    isNpiError,
    onClinicChange,
    onOrderingProviderChange,
  } = useClinicInformation({
    preflight,
    isError,
    isEditMode,
    submittedRequisition,
  });

  if (isLoading) {
    return (
      <ClinicSpinnerWrapper>
        <SpinnerLoading />
      </ClinicSpinnerWrapper>
    );
  }

  return (
    <>
      <Grid container spacing={3} columns={undefined}>
        <Grid item xs={12}>
          {preflight ? (
            <NewRequisitionTextField
              fullWidth
              focused
              label="Clinic Name*"
              placeholder="-"
              variant="standard"
              value={activeRequisition.clinicName || "-"}
              disabled
            />
          ) : (
            <FormField
              fieldTitle="Clinic Name*"
              isError={
                (effectiveIsError || isDraftError) &&
                !activeRequisition.clinicName
              }
              fieldType="autocomplete"
              newRequisition
              autoCompleteDropdownStyle
              autoCompleteStructuredOptions={clinicAutocompleteOptions}
              fieldValue={activeRequisition.clinicAccountNumber}
              onFieldChange={onClinicChange}
              edit
            />
          )}
        </Grid>

        {!preflight && (
          <>
            <Grid item columns={{ xs: 4, sm: 10, md: 12 }}>
              <NewRequisitionTextField
                fullWidth
                focused
                label="Clinic Phone"
                placeholder="-"
                variant="standard"
                value={activeRequisition.clinicPhone || "-"}
                disabled
              />
            </Grid>
            <Grid item columns={{ xs: 4, sm: 10, md: 12 }}>
              <NewRequisitionTextField
                fullWidth
                focused
                label="Clinic Fax"
                placeholder="-"
                variant="standard"
                value={activeRequisition.clinicFax || "-"}
                disabled
              />
            </Grid>
          </>
        )}
        <Grid item columns={{ xs: 4, sm: 10, md: 12 }}>
          <NewRequisitionTextField
            fullWidth
            focused
            label="Clinic Account Number"
            placeholder="15233242"
            variant="standard"
            value={activeRequisition.clinicAccountNumber}
            disabled
          />
        </Grid>
      </Grid>

      <ClinicOrderingProviderSection container spacing={3}>
        <Grid item xs={12}>
          {preflight ? (
            <NewRequisitionTextField
              fullWidth
              focused
              label="Ordering Healthcare Provider*"
              placeholder="-"
              variant="standard"
              value={
                activeRequisition.orderingHealthcareProviderFormatted || "-"
              }
              disabled
            />
          ) : (
            <FormField
              fieldTitle="Ordering Healthcare Provider*"
              fieldType="autocomplete"
              data-testid="healthcare-provider-test"
              newRequisition
              isError={
                ((effectiveIsError || isDraftError) &&
                  !activeRequisition.orderingHealthcareProviders) ||
                isNpiError
              }
              autoCompleteDropdownStyle
              autoCompleteOptions={filteredFormattedOrderingProviders}
              fieldValue={activeRequisition.orderingHealthcareProviderFormatted}
              onFieldChange={onOrderingProviderChange}
              edit
              autoCompleteNoOptionsText="NPI Number Missing/Required"
            />
          )}
        </Grid>
      </ClinicOrderingProviderSection>
    </>
  );
};
export default ClinicInformation;
